export function validate_text(data) {

    const regex = /^([a-zA-Z ])+$/;

    if( regex.test(data) ) return true;

    return "txt158"; 
    
};
